import { DocumentAccessLevel, DocumentStatus } from '@alucio/aws-beacon-amplify/src/models';
import type { DocumentVersionORM } from 'src/types/orms';
import { VERSION_UPDATE_STATUS } from 'src/types/types';
import { GroupStatus } from './groupStatus';

// Combines the folder-list filter with the folder-row interaction guard.
export const canUseFolderDocument = (
  documentVersion: DocumentVersionORM,
  visiblePages?: readonly number[] | null,
): boolean => {
  const isModified = !!visiblePages?.length && documentVersion.meta.permissions.MSLSelectSlides &&
    documentVersion.model.status === DocumentStatus.PUBLISHED;
  return !documentVersion.meta.permissions.MSLNonModifiable &&
    documentVersion.meta.version.isLatestPublished && !isModified &&
    documentVersion.relations.documentORM.model.status !== DocumentStatus.ARCHIVED;
};

export const canSelectIndividualSlides = (
  documentVersion: DocumentVersionORM,
  currentUserEmail?: string,
): boolean => {
  const document = documentVersion.relations.documentORM.model;
  const isOwnUpload = document.accessLevel === DocumentAccessLevel.USER && document.createdBy === currentUserEmail;
  return isOwnUpload || documentVersion.meta.permissions.MSLSelectSlides;
};

export const getPayloadGroupStatus = (documentVersion?: DocumentVersionORM): GroupStatus => {
  if (!documentVersion) return GroupStatus.DELETED;

  const { updateStatus } = documentVersion.meta.version;
  const latestPublishedVersion =
    documentVersion.relations.documentORM.relations.version.latestPublishedDocumentVersionORM;
  const latestVersionIsNonModifiable = latestPublishedVersion?.meta.permissions.MSLNonModifiable;

  if (latestVersionIsNonModifiable) return GroupStatus.DELETED;
  if (updateStatus === VERSION_UPDATE_STATUS.PENDING_MAJOR) return GroupStatus.MAJOR_UPDATE;
  if (updateStatus === VERSION_UPDATE_STATUS.NOT_PUBLISHED) {
    const { status } = documentVersion.relations.documentORM.model;
    return [GroupStatus.DELETED, GroupStatus.REVOKED, GroupStatus.ARCHIVED]
      .find(groupStatus => groupStatus === status) ?? GroupStatus.ACTIVE;
  }
  return GroupStatus.ACTIVE;
};
